export enum DropdownTypeEnum {
    CargoLoadingAndUnloadingOperations = 1,
    Static = 2,
    Tank = 3,
    CargoLoadingOperations = 4,
    CargoUnloadingOperations = 5,
    Charterers = 6,
    ParentEventType = 7,
    BerthList = 8,
}
